/**
 * Redux enabled view for the details confirmation page
 */
import React from 'react';
import PureConfirmDetailsView from './confirm-details-view';
import { useDispatch, useSelector } from 'react-redux';
import { getNewUserState } from 'phoenix2/state/new-user/selectors';
import { popView } from 'phoenix2/state/views/actions';
import { newPasswordConfirmed } from 'phoenix2/state/new-user/actions';
import { getFeatureFlag } from 'phoenix2/state/feature-flags/selectors';
import { FEATURE_FLAG_NEWUSER_STUDENT_CHOOSE_PASSWORD } from 'phoenix2/state/feature-flags';
import { getViewState } from 'phoenix2/state/viewstates/selectors';
import { CONFIRM_DETAILS } from 'phoenix2/state/viewstates/view-ids';
import { setViewState } from 'phoenix2/state/viewstates/actions';
import { Map } from 'immutable';
import { getConfigParameter } from 'phoenix2/state/config-params/selectors';

const blankViewState = Map({ password: '', username: '' });

export const ConfirmDetailsView = () => {
    const newUserState = useSelector(getNewUserState);
    const featureFlag = useSelector(state =>
        getFeatureFlag(state, FEATURE_FLAG_NEWUSER_STUDENT_CHOOSE_PASSWORD),
    );
    const viewState = useSelector(state => getViewState(state, CONFIRM_DETAILS)) || blankViewState;
    const disableAnimations = !!useSelector(state =>
        getConfigParameter(state, 'disableAnimations'),
    );
    const dispatch = useDispatch();

    return (
        <PureConfirmDetailsView
            disableAnimations={disableAnimations}
            usingChoosePassword={featureFlag}
            onBack={() => dispatch(popView())}
            onSubmit={() => dispatch(newPasswordConfirmed())}
            password={newUserState.get('password')}
            userName={newUserState.get('username')}
            typedUsername={viewState.get('username')}
            typedPassword={viewState.get('password')}
            updateViewState={(username, password) => {
                dispatch(setViewState(CONFIRM_DETAILS, Map({ username, password })));
            }}
        />
    );
};
